import { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { updateInstitution } from "@/Services/institutions.service";
import { useToast } from "@/hooks/use-toast";
import type { InstitutionUpdate } from "../types";

export function useInstitutionMutations(institutionId: string) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdate = useCallback(
    async (updates: InstitutionUpdate, userId: string) => {
      setIsSubmitting(true);
      try {
        const updated = await updateInstitution(institutionId, updates, userId);
        await queryClient.invalidateQueries({ queryKey: ["institutions"] });
        toast({ title: "Institución actualizada" });
        return updated;
      } catch (error) {
        toast({
          variant: "destructive",
          title: "Error al actualizar",
          description: error instanceof Error ? error.message : "Error inesperado",
        });
        return null;
      } finally {
        setIsSubmitting(false);
      }
    },
    [institutionId, queryClient, toast],
  );

  return { updateInstitution: handleUpdate, isSubmitting };
}
